import { AiImageIcon, DashboardSquare01Icon, Layers01Icon, PaintBoardIcon, SparklesIcon } from '@hugeicons/core-free-icons';
/**
 * The Solar accessibility outline the extension's workflow card and team
 * review's Run Workflows row draw (each surface's workflowGlyphs.tsx), in the
 * Hugeicons data shape so the DOM toolbar's createIcon can draw it too.
 */
const ACCESSIBILITY_ICON = [
    ['circle', { cx: '12', cy: '12', r: '10', stroke: 'currentColor', strokeWidth: '1.5', key: '0' }],
    ['path', { d: 'M14 7a2 2 0 1 1-4 0a2 2 0 0 1 4 0Z', stroke: 'currentColor', strokeWidth: '1.5', key: '1' }],
    ['path', { d: 'M18 10s-3.537 1.5-6 1.5S6 10 6 10m6 2v1.452m0 0a3 3 0 0 0 .476 1.623L15 19m-3-5.548a3 3 0 0 1-.476 1.623L9 19', stroke: 'currentColor', strokeLinecap: 'round', strokeWidth: '1.5', key: '2' }],
];
/**
 * One glyph per workflow card id (WORKFLOW_CARD_DESCRIPTIONS keys), the same
 * shapes the Workflows tab cards and team review's menu draw, so a workflow
 * reads as the same thing on the capture toolbar's menu.
 */
export const WORKFLOW_GLYPH_ICONS = {
    'auto-review': SparklesIcon,
    'ai-visual-comparison': AiImageIcon,
    'visual-comparison': Layers01Icon,
    'accessibility-audit': ACCESSIBILITY_ICON,
    'design-tokens': PaintBoardIcon,
    components: DashboardSquare01Icon,
};
//# sourceMappingURL=workflowGlyphData.js.map